import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth.service';
import { CommonService } from './services/common.service';
import { Subject } from 'rxjs';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil, map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'vtc-helpdesk-frontend';
  isCollapsed: boolean = true;//是否收起来
  isMenuCollapsed: boolean = true;//是否收起来
  basicInfo: any = {}//用户基本信息
  loginDisplay = false;
  isLoginRedirecting = false;
  isMobile = false;
  isTicket = false;
  link = '';
  isTermsAndConditionsVisible = false;
  isCookieWarningVisible = false;

  showTermsAndConditionsModal(): void {
    this.isTermsAndConditionsVisible = true;
  }

  handleTermsAndConditionsClose(): void {
    this.isTermsAndConditionsVisible = false;
  }

  showCookieWarningModal(): void {
    this.isCookieWarningVisible = true;
  }

  handleCookieWarningClose(): void {
    this.isCookieWarningVisible = false;
  }

  private readonly _destroying$ = new Subject<void>();
  isShowRole: boolean = false;
  constructor(
    private translate: TranslateService,
    private commonService: CommonService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private broadcastService: MsalBroadcastService,
    private msalService: MsalService,
    private authService: AuthService,

  ) { }
  ngOnInit(): void {
    this.link = window.location.host+'/#/ticket';
    if(window.location.hash.includes('#/ticket')){
      this.isTicket = true;
      return;
    }
    this.isMobile = this.commonService.IsMobile();
    this.initializeTranslation();

    // Initialize authentication state
    this.initializeAuthentication();
  }

  private initializeAuthentication() {
    // Check and set active account immediately
    this.authService.checkAndSetActiveAccount();

    // Set initial login display state
    this.setLoginDisplay();

    // Subscribe to account info changes
    this.authService.msalAccountInfo$$
      .subscribe((accountInfo) => {
        console.log('📱 App component accountInfo changed:', accountInfo);
        if (accountInfo) {
          // Only make API calls if we have a valid authenticated account
          this.authService.getAccessRight().subscribe((accessRight) => {
              console.log('📱 App component getAccessRight success:', accessRight);
              if(this.haveAdminPageRight(accessRight)){
                this.isShowRole = true;
              }
            });
        }
      });

    // Subscribe to auth state changes from auth service
    this.authService.authStateChange.subscribe(() => {
      console.log('Auth state change event received, updating login display');
      this.setLoginDisplay();
    });

    // Subscribe to cookie warning events from auth service
    this.authService.cookieWarningNeeded.subscribe(() => {
      console.log('🍪 Cookie warning event received, showing modal');
      this.showCookieWarningModal();
    });

    // Handle MSAL interaction status changes
    this.broadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((interactionStatus) => {
        console.log('📢 MSAL interaction status: None');
        this.isLoginRedirecting = false;
        this.authService.checkAndSetActiveAccount();
        this.setLoginDisplay();
      });

      this.broadcastService.inProgress$
        .pipe(
          filter(
            (status: InteractionStatus) => status === InteractionStatus.HandleRedirect
          ),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
          console.log('📢 MSAL interaction status: HandleRedirect');
          this.isLoginRedirecting = true;
        });

      // Add debugging for all interaction status changes
      this.broadcastService.inProgress$
        .pipe(
          takeUntil(this._destroying$)
        )
        .subscribe((status) => {
          console.log('🔄 MSAL interaction status change:', status);
        });
  }
  private initializeTranslation() {
    const savedLang = localStorage.getItem('lang');
    if (savedLang === 'zh-HK' || savedLang === 'zh') {
      this.translate.setDefaultLang('zh-HK');
      this.translate.use('zh-HK');
      // Update localStorage to use consistent value
      if (savedLang === 'zh') {
        localStorage.setItem('lang', 'zh-HK');
      }
    } else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
    }
  }
  login() {
    console.log('🔐 App component login() called');
    this.authService.login();
  }

  viewTermsAndConditions() {
    // Add your logic here
    console.log('Viewing terms and conditions');
  }

  setLoginDisplay() {
    // Check both getAllAccounts() and getActiveAccount() for better reliability
    const allAccounts = this.msalService.instance.getAllAccounts();
    const activeAccount = this.msalService.instance.getActiveAccount();

    // Set login display if either method finds an account
    this.loginDisplay = allAccounts.length > 0 || !!activeAccount;

    console.log('setLoginDisplay called:', {
      allAccountsCount: allAccounts.length,
      hasActiveAccount: !!activeAccount,
      loginDisplay: this.loginDisplay
    });

    if (this.loginDisplay) {
      //登录信息获得
      this.basicInfo = allAccounts[0] || activeAccount || {};
      if (allAccounts.length > 0) {
        this.msalService.instance.setActiveAccount(allAccounts[0]);
      }
    }
  }
  mousemoveFunction(): void {
    this.isCollapsed = false;
  }
  mouseleaveFunction(): void {
    this.isCollapsed = true;
  }
  navigateToInquiryPage():void{
    window.location.reload();
  }

  // Debug method to manually refresh authentication state
  refreshAuthState(): void {
    console.log('Manually refreshing authentication state');
    this.setLoginDisplay();
  }

  haveAdminPageRight(accessRight:any){
    if(accessRight && accessRight.userRoles){
      const  role = accessRight.userRoles.find((role:any)=>{
        return role.roleName == "ROLE_ADMIN"
      })
      if(role){
        return true;
      }
    }
    return false;
  }
  outLink(){
    console.log(this.link);
    window.location.href =  this.link;
  }
}
// Deployment trigger 08/01/2025 15:12:01
